import React from "react";
import CustomButton from "../../../components/CustomButton";
import { useNavigate } from "react-router-dom";
import { motion, Variants, Easing } from "framer-motion";

const PartnerWithUs = () => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    setTimeout(() => {
      window.scroll(0, 0);
      navigate("/contact");
    });
  };

  const ease: Easing = [0.6, -0.05, 0.01, 0.99];

  const containerVariants: Variants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.2 } },
  };

  const itemVariants: Variants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease } },
  };

  return (
    <motion.div
      className="w-full bg-yellow-500 h-80 flex flex-col items-center justify-center gap-4 py-10 px-3 md:px-24 my-10"
      style={{
        backgroundImage: `url(${require("../../../assets/PartnerWithUs.png")})`,
        backgroundSize: "cover",
      }}
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
      <motion.h2
        className="font-CrimsonText font-bold text-xl md:text-2xl text-white text-center"
        variants={itemVariants}
      >
        Partner with us
      </motion.h2>

      <motion.p
        className="font-CrimsonText font-normal text-sm md:text-base lg:text-xl text-white text-center"
        variants={itemVariants}
      >
        By fostering strong partnerships, we empower ourselves to effectively
        address the ever-changing needs of our valued clients, embracing agility
        and adaptability. Let's engage in a conversation to explore how we can
        further enhance our collective offerings and seize upcoming
        opportunities.
      </motion.p>

      <motion.div variants={itemVariants}>
        <CustomButton
          title="Contact Us"
          className="text-white hover:bg-white hover:text-textColor"
          onClick={handleNavigation}
        />
      </motion.div>
    </motion.div>
  );
};

export default PartnerWithUs;
